/* eslint-disable */

import { gsap } from "gsap/all";
import'../js/header.js';
import'../js/links.js';

import successPageAnimate from '../js/animate-in.js';

export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // *******************************************
    // * Page INIT
    // *******************************************

    const init = () => {
      firstLoadAni();
      setTimeout(() => {
        successPageAnimate('contactAniTxt');
      },300);

    };

    // *******************************************
    // * First Paint
    // *******************************************

    const firstLoadAni = () => {

      setTimeout( () => {
        gsap.to( '#bgFadeIn' , 0.4 , {
          opacity: 1,
          ease: 'power1.in'
        })

        setTimeout( () => {
          gsap.to( '.app-wrapper' , 0.5 , {
            opacity: 1,
            ease: 'power1.in',
          })
          // starsAnimate();
        },350);

      },0);

    }

    // *******************************************
    // * stars animation
    // *******************************************

    const starsAnimate = () => {

      const tlStarS = gsap.timeline({ repeat: -1 , repeatDelay: 0 });
      tlStarS.to( '.star-svg.st-small' , 7 , { rotate: 360, ease: "none"});
      const tlStarL = gsap.timeline({ repeat: -1 , repeatDelay: 0 });
      tlStarL.to( '.star-svg.st-big'  , 12 , { rotate: 360 , ease: "none" });

    }

    if(document.getElementById('contactPage')) init();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/contact.js